<template>
  <div class="vue-uppy-dashboard-wrapper">
    <dashboard
        :uppy="uppy"
        :props="dashboardProps"
    />
    <p v-if="errorMessage" class="mt-2 text-sm text-red-600">{{ errorMessage }}</p>
    <input type="hidden" name="_uppy_latest" :value="latestUploaded">
  </div>
</template>

<script>

import { Dashboard } from '@uppy/vue'

import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';

import Uppy from '@uppy/core';
// import Webcam from '@uppy/webcam';
import XHRUpload from '@uppy/xhr-upload';

export default {
  name: 'UppyWrapper',
  components: {
    Dashboard,
    XHRUpload,
  },
  props: {
    maxFileSizeInBytes: {
      type: Number,
      required: false,
      default: 1100000,
    },
    maxNumberOfFiles: {
      type: Number,
      required: false,
    },
    endPoint: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: false,
      default: 'Dashboard'
    },
    showSelectedFiles: {
      type: Boolean,
      required: false,
      default: true,
    },
    autoProceed: {
      type: Boolean,
      required: false,
      default: false,
    },
    allowedFileTypes: {
      type: Array,
      required: false,
      default: ['.jpg', '.jpeg', '.png']
    }
  },
  methods: {
    setErrorMessage(message) {
      this.errorMessage = message;
    }
  },
  data() {
    return {
      errorMessage: '',
      uploadedFiles: [],
      latestUploaded: '',
    }
  },
  setup(props) {
    const autoProceed = props.autoProceed;
    const height = 330;
    const id = props.id;
    const endPoint = props.endPoint;
    const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    const uppyOpts = {
      autoProceed: props.autoProceed,
      restrictions: {
        maxNumberOfFiles: props.maxNumberOfFiles,
        maxFileSize: props.maxFileSizeInBytes,
        allowedFileTypes: props.allowedFileTypes,
      }
    };

    const dashboardProps = {
      theme: 'light',
      height: height,
      id: id,
      width: '100%',
      proudlyDisplayPoweredByUppy: false,
      showSelectedFiles: props.showSelectedFiles
    };


    return {
      dashboardProps,
      autoProceed,
      endPoint,
      csrf,
      uppyOpts,
      id,
    }
  },
  created() {

    let opts = this.uppyOpts;
    let id = this.id;
    //console.log(opts);
    this.uppy = new Uppy(
        opts
    ).use(XHRUpload, {
      endpoint: this.endPoint + '?upid=' + id,
      headers: {'X-CSRF-Token': this.csrf},
      getResponseError(content, xhr) {
        return JSON.parse(content);
      }
    }).on('upload-error', (file, error, response) => {

      this.errorMessage = response.body.message;
    }).on('upload-success', (file, response) => {
      this.errorMessage = '';
      this.uploadedFiles = [].concat(response.body.path);
      this.latestUploaded = response.body.path;
    })
  },
  beforeDestroy() {
    this.uppy.close()
  }
}
</script>

<style scoped>

</style>